function photoView(id,props) {
	this.ident = id;
	this.properties = props;
	this.photoLoaded = false;

	swipe = new swiper();
	
	if (Screen.xs()) $("#info").hide();

	SpeechManager.enableSpeech("#ui", ".speaks", 1, "TOPMENU");
}

photoView.prototype = {
	rx: 0,
	ry: 0,
	lrx:0,
	lry:0,
	inX: 0,
	inY: 0,
	panning:false,
	swipe:{},
	pd:null,
	gps:null,
	title:null,
	ia:null,
	wwidth:0,
	wheight:0,
	isStart:false,
	layers:[],
	node:null,
	opacity:0,
	scaleFactor:1,
	infoState: "",
	autorun: "",
	autorunDir: -1,
	autorunT: null,
	zooming: 0,
	pivot: {"x": 0, "y": 0},

	load: function() {
		this.layers = [];

		//console.log("photoview.load")

		this.spots = this.properties.properties.spots;

		//console.log(PROJECT.settings['mobile/startbutton']);

		if (this.wwidth < 600) {
			//if (PROJECT.settings['mobile/startbutton'] != "0") 
				HotSpotManager2D.setMobile(true);
			//else HotSpotManager2D.setVisibility(false);
		} else {
			//if (PROJECT.settings['mobile/startbutton'] != "0") 
				HotSpotManager2D.setMobile(false);
			//else HotSpotManager2D.setVisibility(true);
		}

		this.infoState = player.current.properties.info_state;

		if ((this.infoState == 'full' || this.infoState == 'fullext') && $(window).width() > 400) {
			this.txm = 500;
			this.cntx = 0.75;
		} else {
			this.txm = 0;
			this.cntx = 1;
		}

		this.loadQuality(764);

		HotSpotManager2D.addAll(this.spots);

		var self;

		self = this;
		
		AppEvent.on(player, "MENU.INFOWINDOW.TOGGLE", function(state) {
			//console.log("jest trigger");
			//console.log(state);
			//console.log(self);
			
			if (state && self != undefined) {
				self.infoState = 'full';
			} else {
				self.infoState = '';
			}
			
			//console.log(self);
			//console.log("ok");
		});
		
		this.kde = AppEvent.on(player, "PLAYER.KEYDOWN", function(event) {
			if (event.key == '+') {
				self.zooming = 1;
				$(".zoomtools .zoomout").addClass("z-active");
			}
			if (event.key == '-') {
				self.zooming = -1;
				$(".zoomtools .zoomin").addClass("z-active");
			}
		});

		this.kue = AppEvent.on(player, "PLAYER.KEYUP", function(event) {
			if (event.key == '+' || event.key == '-') {
				self.zooming = 0;
				$(".zoomtools .zoomin").removeClass("z-active");
				$(".zoomtools .zoomout").removeClass("z-active");
			}

			if (event.key == 'Escape') player.back();
		});
	},

	addTools: function() {		
		if (!this.isStart && player.currentView.properties.properties != undefined && player.currentView.properties.properties.layers_mode == "1") {
			player.zoomtools = $("<div class='zoomtools'><a href='javascript:void(null)' class='zoomout speaks' data-speak='PLAYER.ZOOM_IN' data-speakgroup='TIPS' title='" + TPL.lng("tips.clicktozoomin", 'Kliknij aby przybliżyć') + "' style='line-height:26px;'>+</i></a><a href='javascript:void(null)' class='zoomin speaks' data-speak='PLAYER.ZOOM_OUT' data-speakgroup='TIPS'title='" +  TPL.lng("tips.clicktozoomout", 'Kliknij aby oddalić') + "' style='line-height:18px;'>-</i></a><a href='javascript:void(null);' class='reset speaks' data-speak='PLAYER.RESET' data-speakgroup='TIPS'>Reset</a></div>");
			$("#player").append(player.zoomtools);
			//this.node.append(player.zoomtools);

			SpeechManager.enableSpeech(".zoomtools", ".speaks", 0, "TIPS");

			var self = this;

			player.zoomtools.find(".zoomin").on(Events.pointer.down, function() {
				self.zooming = -1;
				//console.log(self.infoState);
				if (self.infoState != '') {
					Menu.hideinfowindow();
				}
			});

			player.zoomtools.find(".zoomin").on(Events.pointer.up, function() {
				self.zooming = 0;
			});

			player.zoomtools.find(".zoomin").on("mouseout", function() {
				self.zooming = 0;
			});

			player.zoomtools.find(".zoomout").on(Events.pointer.down, function() {
				self.zooming = 1;
				//console.log(self.infoState);
				if (self.infoState != '') {
					Menu.hideinfowindow();
				}
			});

			player.zoomtools.find(".zoomout").on("mouseup", function() {
				self.zooming = 0;
			});

			player.zoomtools.find(".zoomout").on("mouseout", function() {
				self.zooming = 0;
			});

			player.zoomtools.find(".reset").on("click", function() {
				self.scaleFactor = 1;
				self.rx = 0;
				self.lrx = 0;
				self.ry = 0;
				self.lry = 0;
			});
		}
	},

	reorient: function() {
//		var ww = $(window).width();
//		var wh = $(window).height();
		var ww = $("#player").width();
		var wh = $("#player").height();
		var ny;
		var nx;
		var nh;
		var ow;
		var oh;
		
		this.wwidth = ww;
		this.wheight = wh;

		if (this.wwidth < 600) {
			//if (PROJECT.settings['mobile/startbutton'] == "1") 
				HotSpotManager2D.setMobile(true);
			//else HotSpotManager2D.setVisibility(false);
		} else {
			//if (PROJECT.settings['mobile/startbutton'] == "1")
				HotSpotManager2D.setMobile(false);
			//else HotSpotManager2D.setVisibility(true);
		}

		//if (ww * 0.5 < wh) {

		ia = this.ia;

		ow = ia.naturalWidth;
		oh = ia.naturalHeight;
		
		if (!this.isStart && player.currentView.properties.properties != undefined && player.currentView.properties.properties.layers_mode == "1") {
			if (ww > wh) {
				ia.width = ww;
				nw = ww;
				nh = oh * (ia.width / ow);
				ia.height = nh;
			} else {
				ia.height = wh;
				nh = wh;
				nw = ow * (ia.height / oh);
				ia.width = nw;
			}
		} else {
			if (player.currentView.properties.properties.fit == undefined || player.currentView.properties.properties.fit == "cover") {
				ia.width = ww;
				nh = oh * (ia.width / ow); 
				ia.height = nh;
			} else if (player.currentView.properties.properties.fit == "mobile") {
				var ph = wh;
				var pw = ww;

				ia.width = pw;
				ia.height = ph;
				ia.style = "object-fit: cover; object-position: center";
				if (player.currentView.properties.properties.bgcolor != undefined) pd.css("background-color", player.currentView.properties.properties.bgcolor);
			} else if (player.currentView.properties.properties.fit == "contain") {
				var ph = wh;
				var pw = ww;

				if (player.currentView.properties.properties.margintop != undefined) {
					pd.css("padding-top", player.currentView.properties.properties.margintop + "px");
					ph -= player.currentView.properties.properties.margintop;
				}

				if (player.currentView.properties.properties.marginbottom != undefined) {
					pd.css("padding-bottom", player.currentView.properties.properties.marginbottom + "px");
					ph -= player.currentView.properties.properties.marginbottom;
				}

				if (player.currentView.properties.properties.hmargin != undefined) {
					pd.css("padding-left", player.currentView.properties.properties.hmargin + "px");
					pd.css("padding-right", player.currentView.properties.properties.hmargin + "px");
					pw -= player.currentView.properties.properties.hmargin * 2;
				}

				ia.width = pw;
				ia.height = ph;
				ia.style = "object-fit: contain";
				if (player.currentView.properties.properties.bgcolor != undefined) pd.css("background-color", player.currentView.properties.properties.bgcolor);
			}
//			console.log("oh: " + oh + " ; w: " + ia.width + " ; ow:" + ow);
//			console.log(nh);
		}
		
		if (nh == 0) nh = wh;
		if (nw == 0) nw = ww;

		ny = (wh * 0.5) - Math.round(nh * 0.5);
		if (ny < 0) ny = 0;
		
		nx = (ww * 0.5) - Math.round(nw * 0.5);
		if (nx < 0) nx = 0;		

		// if dodane 26.05.2020
		// na mniejszych ekranach nie centrowal dobrze zdjec w galerii na warstwach jezeli byly ustawione te cssy
		if (player.currentView.properties.properties == undefined || player.currentView.properties.properties.layers_mode != "1") {
			pd.css("top",ny + "px");
			pd.css("left",nx + "px");
		}

		if (wh > ww && ny > 100) {
			title.show();
			gps.show();
			
			gps.css("top",ny + ia.height + "px");
			//gps.css("top","700px");			
			
			var ty = ny * 0.5 - title.height() * 0.5;
			if (ty < 50) ty = 50;
			title.css("top", ty + "px");
		
		} else {
			title.hide();
			gps.hide();
		}
		
		var ww = $(window).width() - this.txm;
		var wh = $(window).height() - 50;
		
		if (!this.isStart) {
			
			var lidx = 0;

			for(layerno in this.layers) {
				var nw = -1;

				var layer = this.layers[layerno];

				var limg = layer.children("img").get(0);

				var layer_x = parseInt(player.currentView.properties.properties.layer_x[lidx]);
				var layer_y = parseInt(player.currentView.properties.properties.layer_y[lidx]);
				var layer_scale = parseFloat(player.currentView.properties.properties.layer_scale[lidx]);

				var natw = limg.naturalWidth * (layer_scale * 1.555);
				var nath = limg.naturalHeight * (layer_scale * 1.555);

				limg.width = natw;
				limg.height = nath;

				if (natw > nath) {
					
					if (natw > ww * 0.85) {
						limg.width = ww * 0.85;
						limg.height = nath * (limg.width / natw);
						nw = limg.width;

						if (limg.height >  wh * 0.85) {
							limg.height = wh * 0.85;
							limg.width = natw * (limg.height / nath);
						}
					}

				} else {

					if (nath > wh * 0.85) {
						limg.height = wh * 0.85;
						limg.width = natw * (limg.height / nath);

						if (limg.width >  ww * 0.85) {
							limg.width = ww * 0.85;
							limg.height = nath * (limg.width / natw);							
						}
					}

				}

				if (layer_x == 0 && layer_y == 0) {
					var cx = ww * 0.5 - limg.clientWidth * 0.5;
					var cy = wh * 0.5 - limg.clientHeight * 0.5;

					layer.css("transform","translate3d(" + cx + "px, " + cy + "px, 0px)");
					layer.css("-webkit-transform","translate3d(" + cx + "px, " + cy + "px, 0px)");
				} else {
					var cx = (layer_x / 1000) * ww;
					var cy = (layer_y / 500) * wh;

					if (cx + limg.width + 20 > ww) {
						cx = ww - (limg.width + 20);
					}
					if (cy + limg.height + 20 > wh) cy = wh - (limg.height + 20);

					layer.css("transform","translate3d(" + cx + "px, " + cy + "px, 0px)");
					layer.css("-webkit-transform","translate3d(" + cx + "px, " + cy + "px, 0px)");
				}
			
				lidx ++;
			};
		};
	},
	
	loadQuality: function(q) {
		ia = new Image();

		this.ia = ia;

		$(ia).attr("aria-hidden", "true");

		if (this.properties.priority >= 10) {
			this.isStart = true;
			
			if (player.offline) {
				var lng = "";
				if (player.lang != "PL") lng = "_" + player.lang;
//				ia.src = "data/photo_" + this.properties.place_id + lng + ".jpg";
				ia.src = "data/screen_" + this.properties.place_id + lng + ".jpg";
			} else
				ia.src = this.properties.image;

		} else {
			if (player.offline) 
				ia.src = "data/photo_" + this.properties.place_id + ".jpg";
			else
//				ia.src = this.properties.image;
				ia.src = "https://www.wkraj.pl/data/" + this.properties.place_id + "_photo.jpg";
		}
		
		if (Screen.xs() && this.properties.properties.mobile_bg == "1") {
			if (player.offline) 
				ia.src = "data/mobile_" + this.properties.place_id + ".jpg";
			else
				ia.src = "https://www.wkraj.pl/data/" + this.properties.place_id + "_mobile.jpg";

			//$(ia).css("object-fit", "cover");
			//$(ia).css("object-position", "center");

			player.currentView.properties.properties.fit = "mobile";
		}

		var self = this;
		
		player.preload(true);

		var cimg;

		// ten warunek dodany na zyczenie PJ 25.12.2023
		// uwaza ze nie potrzeba wracac do panoramy z ktorej sie przyszlo tylko zawsze do tej podanej
		if (player.current.properties.exit != undefined && player.current.properties.exit != "0") {
			player.addTrack(player.current.properties.exit, player.current.properties.exit_angle);
			player.lastIdent = player.current.properties.exit;
			player.lastDir = player.current.properties.exit_angle;
		} else if ((player.lastIdent == undefined || player.lastIdent == null || player.lastIdent == player.ident) && player.current.properties.exit != undefined && player.current.properties.exit != "0") {
			player.addTrack(player.current.properties.exit, player.current.properties.exit_angle);
			player.lastIdent = player.current.properties.exit;
			player.lastDir = player.current.properties.exit_angle;
		}

		if (player.lastIdent != undefined && player.lastIdent != null && player.lastIdent != player.ident) {
			cimg = $("<img src='assets/menu_close.png' width='50' height='50' on" + Events.pointer.up + "='player.back();' class='photoclose speaks' data-speak='PLAYER.CLOSE' data-speakgroup='TIPS' title='" + TPL.lng("back", "Powrót") + "'>");
		}

		self.cimg = cimg;

		ia.onerror = ia.onload = function() {
			var txt;
		
			self.black = $("<div style='position:absolute;left:0px;top:0px;right:0px;bottom:0px;z-index:998;background-color:#000000;'></div>")
			self.black.css("opacity", 0);

			pd = $("<div style='position:absolute;opacity:0;z-index:999;'></div>");
			
			self.node = pd;
			self.layersnode = $("<div style='position:absolute;left:0px;top:50px;pointer-events:none;' class='hqimages'></div>");

			gps = $("<div style='position:absolute;right:10px;padding-top:8px;color:#ffffff;z-index:9999;'>N " + player.currentView.properties.gps_x + "&deg;<br>E " + player.currentView.properties.gps_y + "&deg;</div>");
			
			if (player.currentView.properties.folder != null && player.currentView.properties.folder.parent_folder != null && player.currentView.properties.folder.parent_folder.parent_folder != null && player.currentView.properties.folder.parent_folder.parent_folder.city_name != undefined) txt = player.currentView.properties.folder.parent_folder.parent_folder.city_name + " - ";
			else txt = "";
			
			if (player.currentView.properties.folder.parent_folder != undefined && player.currentView.properties.folder.parent_folder.city_name != undefined) txt += player.currentView.properties.folder.parent_folder.city_name;
			
			title = $("<div style='position:absolute;top:70px;color:#afafaf;z-index:9999;text-align:center;width:100%;font-size:12px'><h1 style='font-size:20px;color:#ffffff'>" + player.currentView.properties.folder.city_name + "</h1>" + txt + "</div>");
			
			var ww = $(window).width();
			var wh = $(window).height();
						
			player.preload(false);
			/*
			ia.style.width = ww + "px";
			ia.style.height = Math.round(ww * 0.5) + "px";
			pd.css("padding-top",(wh - Math.round(ww * 0.5)) * 0.5 + "px");
			*/
			
			if (self.properties.properties.autorun == "d") {				
				setTimeout(function() {
					self.autorun = self.properties.properties.autorun;
				}, 4000);
			}			

			$("#player").css("background-color","#000000");
			//$("#player").html("");
			var link;
//			var cimg;
			
			/*
			if (player.from == "") {
				if (player.currentView.properties.properties != undefined && player.currentView.properties.properties.layers_mode == "1") {
					link = $("<a href='javascript:void(null)'></a>");				
				} else {
					link = $("<a href='javascript:void(null)' ontouchend='player.toggleMenu(null);'></a>");
				}
			} else {				
				if (self.isStart) {
					link = $("<a href='javascript:void(null)' ontouchend='history.back();'></a>");				
				} else {
					link = $("<a href='javascript:void(null)'></a>");				
				}
				
				//link = $("<a href='javascript:void(null)'></a>");				
				
				cimg = $("<img src='assets/menu_close.png' width='50' height='50' on" + Events.pointer.up + "='history.back();' style='pointer-events:all;position:absolute;right:10px;top:10px;'>");
			}
			*/

			link = $("<a href='javascript:void(null)' class='photolink' aria-hidden='true'></a>");

//			console.log(player.lastIdent);
//			console.log(player.ident);

			if (player.currentView.properties.properties.layers_mode != "1" || player.currentView.properties.properties.layers.layer_0 == "") 
				link.append(ia);
			else {
				self.bg = $("<div style='position:absolute;left:0px;top:0px;right:0px;bottom:0px;background-size:cover;z-index:999;'></div>")
				self.bg.css("opacity", 0);
				$("#player").append(self.bg);
				//self.node.append(self.bg);
				self.node.css("width", "100%");
				self.node.css("height", "100%");
				self.bg.css("background-image","url(" + ia.src + ")");
			}

			var limg;
			var layer;
			var layer_x;
			var layer_y;

			self.photoLoaded = true;
						
			if (player.currentView.properties.properties != undefined && player.currentView.properties.properties.layers_mode == "1") {
				if (!self.isStart) {
					if (player.currentView.properties.properties.layers && player.currentView.properties.properties.layers.length > 0) player.preload(true);

					var lrs = {};
					var lidx = 0;

					lrs = {};

					for(lind in player.currentView.properties.properties.layers) {
						layer = player.currentView.properties.properties.layers[lind];

						if (layer != undefined && layer != "") {
							limg = new Image();
							lrs[lind] = limg;
							
							(function(limg, lind, layer, lidx) {
								limg.onload = function() {
									var dimg;
									var ow = limg.width;
									var ww = $(window).width();
									var wh = $(window).height();
									var nw = -1;
									
									var layer_x = parseInt(player.currentView.properties.properties.layer_x[lidx]);
									var layer_y = parseInt(player.currentView.properties.properties.layer_y[lidx]);

									/*
									if (limg.naturalWidth > ww * 0.85) {
										limg.width = ww * 0.85;
										nw = limg.width;
									}
									
									if (limg.naturalHeight > wh * 0.85) {
										limg.height = wh * 0.85;
										if (nw > -1) {
											limg.width = limg.naturalWidth * (limg.height / limg.naturalHeight);
											if (limg.width > ww * 0.85) {
												limg.width = ww * 0.85;
												nw = limg.width;
												limg.height = limg.naturalHeight * (limg.width / limg.naturalWidth);
											}
										}
									}
									*/

									/* dla wielu warstw, ale to nie dziala poprawnie - krakow.wkraj.pl
									dimg = $("<div style='position:absolute;left:50%;top:50%;margin-left:" + (-Math.round(limg.width * 0.5)) + "px;margin-top:" + (-Math.round(limg.height * 0.5)) + "px'></div>");
									dimg.append(limg);
									link.append(dimg);
									*/
									
									var lr = $("<div style='position:absolute;left:0px;top:0px;z-index:" + (1000 + lind) + "'></div>");
									lr.css("opacity", 0);

									lr.append(limg);
									self.layers.push(lr);
									
									//$("#player").append(lr);
									self.layersnode.append(lr);


									if (layer_x == 0 && layer_y == 0) {
										var cx = ww * 0.5 - limg.clientWidth * 0.5;
										var cy = wh * 0.5 - limg.clientHeight * 0.5;
										lr.css("transform","translate3d(" + cx + "px, " + cy + "px, 0px)");
										lr.css("-webkit-transform","translate3d(" + cx + "px, " + cy + "px, 0px)");										
									} else {										
										var cx = (layer_x / 1000) * ww;
										var cy = (layer_y / 500) * wh;
										lr.css("transform","translate3d(" + cx + "px, " + cy + "px, 0px)");
										lr.css("-webkit-transform","translate3d(" + cx + "px, " + cy + "px, 0px)");
									}

									self.reorient();

									var t = new Tween(function(o) {
										lr.css("opacity", o);
									}, function() {});
									//t.wait(1500).start(0, 1, 1000);
									t.start(0, 1, 1000);

									player.preload(false);
								};
							})(limg, lind, layer, lidx);
							// $path = "http://www.wkraj.pl/thumbscreen.php?scale=50&file=".screenshotFile($spot['place_id'],"0","../");
							lidx ++;
							
							if (!player.offline) {
								//limg.src = "http://www.wkraj.pl/thumbscreen.php?scale=70&ext=png&out=png&file=./data/" + layer;
								limg.src = "https://www.wkraj.pl/data/" + layer;
							} else {
								limg.src = "data/" + layer;
							}
							limg.oncontextmenu = function() {return false;};
							
						}
					}


				}
			}
					
			pd.append(link);
			self.gps = gps;
			self.ctitle = title;

			$("#player").append(self.black);

			$("#player").append(pd);
			//$("#player").append(self.layersnode);
			pd.append(self.layersnode);
			$("#player").append(gps);
			$("#player").append(title);
			
//			if (player.from != "") {
			if (player.lastIdent != null) {
				$("#ui").append(cimg);
			}
			
			self.addTools();

			AppEvent.trigger(player, "PLACE.LOADED", player.currentView);
			//AppEvent.trigger(player, "PLACE.TRANSITIONED", sphereWebGLStatic.self);

			player.currentView.reorient();
		}
	},
	
	process: function() {

		try {
			if (player.keys['ArrowUp']) {
				this.ry += 5;
			}
			if (player.keys['ArrowDown']) {
				this.ry -= 5;
			}


			if (swipe.resizing && !this.isStart) {
				var psf = this.scaleFactor;
				this.scaleFactor += swipe.distance() * 0.005;
				if (this.scaleFactor < 1) this.scaleFactor = 1;
				if (this.scaleFactor > 5) this.scaleFactor = 5;

//				this.ry = (swipe.distMidPoint.y - (ia.height * 0.5)) * this.scaleFactor;
//				console.log((swipe.distMidPoint.y - (im.height * 0.5)) * this.scaleFactor);
				try {
					this.pivot = {
						"x": (-this.rx + (swipe.distMidPoint.x)) / (ia.width * psf),
						"y": (-this.ry + (swipe.distMidPoint.y)) / (ia.height * psf),
					}

					var zdy = (ia.height * this.scaleFactor) - (ia.height * psf);
					var zdx = (ia.width * this.scaleFactor) - (ia.width * psf);

					if (Math.abs(zdy) > 5 || Math.ans(zdx) > 5) {
						this.ry -= zdy * this.pivot.y;
						this.rx -= zdx * this.pivot.x;
					}

				} catch(e) {
					//console.log(e);
				}
			}

			if (this.zooming != 0) {
				this.scaleFactor += this.zooming * 0.01;
				if (this.scaleFactor < 0.5) this.scaleFactor = 0.5;
				if (this.scaleFactor > 5) this.scaleFactor = 5;
			}

			if (this.opacity < 1 && this.photoLoaded) {
				this.opacity += 0.01;//5;
				this.node.css("opacity", this.opacity);
				if (this.bg != undefined) {
					this.bg.css("opacity", this.opacity);
				}
				if (this.black != undefined) {
					this.black.css("opacity", this.opacity);
				}
				if (this.opacity >= 1) {
					AppEvent.trigger(player, "PLACE.TRANSITIONED", this);
				}
			}

			var dx = -swipe.inertiaX() * 10;// + 0.02; // 0.02
			var dy = swipe.inertiaY() * 10;

			if (this.autorun == "d" && player.currentView.properties.properties.layers_mode != "1") {
				if (Math.abs(dy) > 0.01) {
					this.autorun = "";
					var self = this;
					if (this.autorunT != null) clearTimeout(this.autorunT);

					this.autorunT =	setTimeout(function() {
						self.autorun = self.properties.properties.autorun;
						self.autorunT = null;
					}, 6000);

				}
				dy = 0.4 * this.autorunDir;
			}

			if (!swipe.resizing) {
				this.lrx += dx;
				this.lry += dy;
				this.rx += dx;// + 0.02; // 0.02
				this.ry += dy;
			}

			if (this.rx < (ia.width * this.scaleFactor - this.wwidth) * -1) this.rx = (ia.width * this.scaleFactor - this.wwidth) * -1;
			if (this.rx > 0) this.rx = 0;
			
			if (this.ry < (ia.height * this.scaleFactor - this.wheight) * -1) {
				this.ry = (ia.height * this.scaleFactor - this.wheight) * -1;
				this.autorunDir *= -1;
			}
			if (this.ry > 0) {
				this.ry = 0;
				this.autorunDir *= -1;
			}
			
			var cntx = 0.5;
			var txm = 0;
			if ((this.infoState == 'full' || this.infoState == 'fullext') && $(window).width() > 400) {
				cntx = 0.75;
				txm = 500;//$(window).width() * 0.25;
				//this.txm = txm;
				if (this.lastInfoState != this.infoState) {
					this.reorient();
				}
				this.lastInfoState = this.infoState;				
			} else {
				if (this.lastInfoState != this.infoState) {
					cntx = 1;
					txm = 0;
				//	this.txm = txm;
					this.reorient();
				}
				this.lastInfoState = this.infoState;
			}
			
			var step = (txm - this.txm) * 0.03;	
			this.txm += step;
			//this.cntx += (cntx - this.cntx) * 0.03;
			//cntx = this.cntx;
			txm = this.txm;

			if (Math.abs(step) > 0.1) this.reorient();
			
			//console.log(txm + " , " + cntx);
			//if (this.ry < wheight - ia.height) this.ry = 0;
			//if (this.rx + ia.width > wwidth) this.rx = 0;
			
						

			var tstack = "";

			//tstack += "translate3d(" + (-player._mouseX) + "px," + (-player._mouseY) + "px, 0px)";
//			tstack += "translate3d(" + (-$(window).width() * 0.5 * this.scaleFactor) + "px," + (-$(window).height() * 0.5 * this.scaleFactor) + "px, 0px)";
			tstack += "scale(" + this.scaleFactor + "," + this.scaleFactor + ") ";
			tstack += "translate3d(" + (this.lrx + txm) + "px," + this.lry + "px, 0px)";
//			tstack += "translate3d(" + ($(window).width() * 0.5 * this.scaleFactor) + "px," + ($(window).height() * 0.5 * this.scaleFactor) + "px, 0px)";
			//tstack += "translate3d(" + ($(window).width() * 0.5) + "px," + ($(window).height() * 0.5) + "px, 0px)";
			//tstack += "translate3d(" + (player._mouseX) + "px," + (player._mouseY) + "px, 0px)";

			if (this.isStart) {
				pd.css("transform","translate3d(" + this.rx + "px," + this.ry + "px, 0px) scale(" + this.scaleFactor + "," + this.scaleFactor + ")");
				pd.css("-webkit-transform","translate3d(" + this.rx + "px," + this.ry + "px, 0px) scale(" + this.scaleFactor + "," + this.scaleFactor + ")");
			} else {
				pd.css("transform","translate3d(" + this.rx + "px," + this.ry + "px, 0px) scale(" + this.scaleFactor + "," + this.scaleFactor + ")");
				pd.css("-webkit-transform","translate3d(" + this.rx + "px," + this.ry + "px, 0px) scale(" + this.scaleFactor + "," + this.scaleFactor + ")");

//				pd.css("transform-origin", this.pivot.x + "px " + this.pivot.y + "px");
				pd.css("transform-origin", "0px 0px");
//				pd.css("transform",tstack);
//				pd.css("-webkit-transform",tstack);
			}

			/*
			pd.css("transform","translate3d(" + this.rx + "px," + this.ry + "px, 0px) scale(" + this.scaleFactor + "," + this.scaleFactor + ")");
			pd.css("-webkit-transform","translate3d(" + this.rx + "px," + this.ry + "px, 0px) scale(" + this.scaleFactor + "," + this.scaleFactor + ")");
			*/

			this.layersnode.css("transform",tstack);
			this.layersnode.css("-webkit-transform",tstack);

			this.layersnode.css("transform-origin",($(window).width() * cntx) + "px " + ($(window).height() * 0.5) + "px");
			this.layersnode.css("-webkit-transform-origin",($(window).width() * cntx) + "px " + ($(window).height() * 0.5) + "px");
			//this.layersnode.css("-webkit-transform-origin","50% 50%");
			/*
			pd.css("top",this.ry + "px");
			pd.css("left",this.rx + "px");
			*/
		} catch(e) {
		}

		try {
			if (this.node == undefined) {			
				HotSpotManager2D.process($("#player").position(), $("#player").width(), $("#player").height());
			} else {

				var pos = JSON.parse(JSON.stringify(this.node.position()));
				var nw = this.node.width();
				var nh = this.node.height();
				var ratio = this.ia.naturalWidth / this.ia.naturalHeight;

				if (player.currentView.properties.properties.fit == "contain") {
					/*
					if (player.currentView.properties.properties.margintop != undefined) {
						pos.top += parseInt(player.currentView.properties.properties.margintop);
						nh -= parseInt(player.currentView.properties.properties.margintop);
					}

					if (player.currentView.properties.properties.marginbottom != undefined) {
						pos.top += parseInt(player.currentView.properties.properties.marginbottom);
						nh -= parseInt(player.currentView.properties.properties.marginbottom);
					}
					*/
					pos.left = (nw - (nh * ratio)) * 0.5;
					nw = nh * ratio;

					if (player.currentView.properties.properties.hmargin != undefined) {
						pos.left += parseInt(player.currentView.properties.properties.hmargin);
					//	nw -= parseInt(player.currentView.properties.properties.hmargin) * 2;
					}

				}

				HotSpotManager2D.process(pos, nw, nh);
			}
		} catch(e) {
		}
	},	

	mouseDown: function(event) {
		this.panning = true;
		swipe.start(event);
	},
	
	mouseUp: function(event) {
		swipe.end();
		this.panning = false;
	},
	
	mouseMove: function(event) {
		swipe.move(event);
	},

	mouseWheel: function(dt) {
		/* przyblizanie scrollem wylaczone
		this.scaleFactor += dt * 0.001;
		if (this.scaleFactor < 0.7) this.scaleFactor = 0.7;
		if (this.scaleFactor > 5) this.scaleFactor = 5;
		*/
		this.ry += dt;
	},
	
	clear: function() {
		if (this.cimg != undefined) this.cimg.remove();
	},

	leaving: function() {
		this.node.css("z-index","100");
		if (this.bg != undefined) this.bg.css("z-index","100");
		if (this.black != undefined) this.black.css("z-index","100");
		var self = this;

		if (player.zoomtools != undefined) player.zoomtools.remove();

		HotSpotManager2D.clear();

		AppEvent.off(player, "MENU.INFOWINDOW.TOGGLE");

		AppEvent.one(player, "PLACE.TRANSITIONED", function() {
			if (self.gps != null) self.gps.remove();
			if (self.ctitle != null) self.ctitle.remove();
			if (self.black != undefined) self.black.remove();
			if (self.bg != undefined) self.bg.remove();
			if (self.layersnode != undefined) self.layersnode.remove();
			self.node.remove();

			self.kde.remove();
			self.kue.remove();
		});
	},

	pause: function() {
		this.paused = true;
	},

	resume: function() {
		this.paused = false;
	},

	getRX: function() {
		return 0;
	},

	getRY: function() {
		return 0;
	},

	stopTurning: function() {

	}
}